import { t } from '@lingui/core/macro';
import { LucideUsers, ScrollText } from 'lucide-react';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { Outlet } from 'react-router-dom';
import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import { useTenantContext } from '../TenantContext';

export function TeamPage() {
  const tenantCtx = useTenantContext();

  const { data: hasInternalEnrolment } =
    trpcTenant.enrolments.hasInternalCourseEnrolments.useQuery();

  const menuItems = [
    {
      label: t`Members`,
      link: '/team/members',
      icon: LucideUsers,
    },
    ...(hasInternalEnrolment === true &&
    tenantCtx != null &&
    tenantCtx.permissions.includes('canReadInternalEnrolments') === true
      ? [
          {
            label: t`Internal Enrolments`,
            link: '/team/enrolments',
            icon: ScrollText,
          },
        ]
      : []),
  ];

  return (
    <SidebarLayout items={menuItems} label={t`Team`}>
      <Outlet />
    </SidebarLayout>
  );
}
